import React from "react";
import { Label } from "semantic-ui-react";

const StatusLabels = (props) => {
  return (
    <Label.Group className="mr-1">
      {props?.labels?.map((label) => {
        return (
          <Label
            key={label.color}
            color={label.color}
            basic={label.disabled}
            className="clickable"
            onClick={() => props.onClick(label.key)}
            style={{ border: "1px solid" }}
          >
            {label.text}
            <Label.Detail>{label.quantity}</Label.Detail>
          </Label>
        );
      })}
    </Label.Group>
  );
};

export default StatusLabels;
